import React, { useContext, useState, useRef } from "react";
import style from "./SaveOption.module.css";
// import {AppContext} from '../../../../Resources/CanvasContextFile'
import axios from "../../../../axios";
import {
  downloadJson,
  sanitizeJson,
  sanitizeStringToJson,
  sanitizeStringToString
} from "../../../../Resources/globalFunctions";
import { useTranslation } from "react-i18next";
import { addContexts, useSelector,useDispatch } from "../../../../Redux";
import SimpleLoader from "../../../../UI/General/SimpleLoader";
import MuiAlert from "@material-ui/lab/Alert";
import { checkValid, isObjectEmpty } from "../../../../Resources/globalFunctions";
import Snackbar from "@material-ui/core/Snackbar";
import DownArrow1 from "../../../../Icons/DownArrow";
import { makeStyles } from "@material-ui/core/styles";
import { defaultBuffer } from "../../../../Resources/defaultBuffer";
import secureLocalStorage from "react-secure-storage";
import { getChangeCanvasLayout, getFormId, getFormJsonFromStore } from "../../IFormDesignerLogic";
import cloneDeep from "lodash-es/cloneDeep";
import { functions } from "../../ApplicationAPI/applicationApi";
import { GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { GetState } from "../../../CustomHooks/CustomHooks.js";
import { updateStateInRedux } from "../../../../Redux/Actions/FormStateActions.js";
import CustomizedAlert from "../../../../ReusableComponents/Alert/CustomizedAlert.jsx";
import { updateFormStateWithoutRender } from "../../../../Redux/Actions/FormStateActions";
import { formStateStore } from "../../../../Redux/Store/store";


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SaveOption = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const useStyles = makeStyles(() => ({
    previewButton: {
      display: "flex",
      alignItems: "center",
      "&:hover": {
        textDecoration: "none"
      }
    },
    saveDropDown: {
      position: "absolute",
      // width:"150px",
      width: "0",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      top: "2em",
      left: "-9em",
      boxShadow: "0px 0px 6px #00000029",
      borderRadius: "2px",
      textAlign: "start",
      zIndex: "1",
      background: "#fff",
      color: "#000",
      padding: "0 !important",
      "&:focus": {
        padding: "6px 15px !important",
        width: "max-content",
        overflow: "unset"
      },
      "&:hover": {
        background: "#d6eeff"
      }
    },
    alertStyle: {
      "& .MuiAlert-icon": {
        //   fontSize: "16pt",
        margin: translationStyles1 ? "0 0 0 12px !important" : "0 12px 0 0 !important"
        //   padding:"0 !important"
        // paddingRight: "16px",
        // paddingLeft: "16px",
        // paddingTop: "10px"
      }
    }
  }));
  const classes = useStyles();
  const contexts = GetStateFromData(props.containerId);
  const {saveload} = GetState(
    "saveload",
  );
  const dispatch = useDispatch();
  const {
    updateJson,
    formState2,
    activePage,
    activeSubForm,
    activeApplication,
    builderMode,
    showPagesSubForms,
    setShowPagesSubForms,
    formBuillderMode,
    applicationData,
    setFormState2,
    setLatestChangesSaved,
    containerId,
    microFrontendComponentType,
    microFrontendData,
    setEventList
  } = contexts.contexts;

  let headerJSON;
  let islogin;
  if (applicationData) {
    headerJSON = applicationData.headerJSON;
    islogin = applicationData.islogin;
  }

  const { saveFormState } = updateJson;
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
  });
  // const islogin = applicationDataVar?.islogin;

  const { t } = useTranslation();

  const openLoader = useRef();
  const flag2 = useRef(0);
  const flag3 = useRef();

  function setOpenLoader(val) {
    openLoader.current = val;
  }

  let foundjson = [];

  const getControlByElemType = (formState2JSON, elemType = "") => {
    if (formState2JSON && elemType) {
      if (formState2JSON?.elem_type === elemType) {
        foundjson.push(formState2JSON);
      } else {
        if (formState2JSON?.children?.length) {
          formState2JSON.children.forEach((child) => {
            if (child?.elem_type) {
              if (child?.elem_type === elemType) {
                foundjson.push(child);
              } else {
                getControlByElemType(child, elemType);
              }
            }
          });
        } else if (formState2JSON.subform) {
          getControlByElemType(formState2JSON.subform, elemType);
        } else if (formState2JSON.listviewFrameLayoutJson) {
          getControlByElemType(formState2JSON.listviewFrameLayoutJson, elemType);
        }
      }
      return foundjson;
    }
  };

  const sendDocListData = () => {
    const docListData = [];
    const docListDataFromJSON = getControlByElemType(formState2, "doclist") || [];
    console.log("nkb docListData dataclass documents DocumentName", docListDataFromJSON);

    if (docListDataFromJSON.length) {
      const mappedDoclist = docListDataFromJSON.filter((item) => item.dataclass);

      if (mappedDoclist.length) {
        mappedDoclist.forEach((item) => {
          const tableName = item.dataclass.split(".");

          docListData.push({
            doclistGrandParentTableName: tableName?.[tableName?.length ? tableName.length - 3 : 0] || "",
            doclistParentTableName: tableName?.[tableName?.length ? tableName.length - 2 : 0] || "",
            doclistTableName: tableName?.[tableName?.length ? tableName.length - 1 : 1] || "",
            documentTypes:
              item.documents
                ?.map((docType, index) => (index === 0 ? docType.DocumentName : `#${docType.DocumentName}`))
                .join("") || ""
          });
        });
      }
    }
    const docListDataToSend = {
      formId: `${
        microFrontendData?.formDefId ||
        activePage?.formId ||
        activeSubForm?.fragmentId ||
        microFrontendData?.processDefId ||
        microFrontendData?.templateId
      }`,
      docListData: docListData || []
    };
    console.log("nkb docListDataToSend", docListDataToSend);
    if (docListData.length > 0) {
      axios.post("idesign/createDocTableRecord", docListDataToSend, { withCredentials: true });
    }
  };

  //     const [newPage,setNewPage]=useState({
  //         processDefId:0,
  //         // formId:"",
  //         formName:"Page 1",
  //         formBuffer:JSON.stringify(defaultBuffer),
  //         isEncrypted:"N",
  //         lastModifiedOn:new Date(),
  //         deviceType:"A",
  //         formHeight:400,
  //         formWidth:400,
  //         existingFormId:"",
  //         formType:"P"
  // });
  // const callSpecifiedFunctions =( extraFunctionCall) => {
  window.callSpecifiedFunctions = async function (activeApplication1 = {}, str = "", url = "", silentSave = false) {
    // window?.takeScreenshot();
    // if(saveFormState){
    // saveFormState();
    // }
    if(silentSave){
      dispatch(updateStateInRedux({name:"saveload",key:props?.containerId,value:true}))
    }
    return new Promise(async(resolve, reject) => {
      if (!silentSave && str === "openApplicationPreview" || str ==="OpenSelectedPagePreview") {
        window.loading(true);
        const changeCanvasLayout = getChangeCanvasLayout();
        changeCanvasLayout(3,"web","none");
      } 
      setEventList([]);
      flag3.current = { activeApplication1, str, url };
      if (!silentSave) setOpenLoader(true);
      const toUpdateElemCountJson = {
        formJson: JSON.stringify(formState2)
      };

      const formattedData = { ...activeApplication, lastModifiedOn: new Date() || "" };
      functions.fixElementIndex();
      let formStateToSend = {};
      if (Object.keys(formState2).length === 0) {
        formStateToSend = getFormJsonFromStore();
      } else {
        formStateToSend = cloneDeep(formState2);
      }

      if (Object.keys(formStateToSend).length !== 0 && Object.keys(formStateToSend?.children).length > 0) {
        let formId = getFormId();
        formStateToSend.formName = activePage?.formName || microFrontendData?.formName || activeSubForm?.fragmentName || formState2.formName || "testprocess";
        formStateToSend.id = microFrontendData?.formDefId;
        formStateToSend.formId = formId?.toString();

        formState2.formName = activePage?.formName || microFrontendData?.formName || activeSubForm?.fragmentName ||formState2.formName || "testprocess";
        formState2.id = microFrontendData?.formDefId;
        formState2.formId = formId?.toString();
        await axios
          .post("idesign/updateElementCountInJson", sanitizeJson(formStateToSend), { withCredentials: true })
          .then(async(res) => {
            // console.log("SAVED PAGE");

            setOpenLoader(false);
            formState2.ElementCount = { ...res.data.ElementCount }
            setFormState2(formState2);
            saveProcess(res.data, url,silentSave);
            flag2.current = { ...res.data.ElementCount };
            const activePageNew = {
              ...activePage,
              formBuffer: JSON.stringify(res.data || defaultBuffer),
              headerJSON: headerJSON || {},
              islogin: islogin || "N"
            };
            // const santizedPageNew=sanitizeJson(activePageNew);

            const activeSubFormNew = {
              ...activeSubForm,
              fragmentBuffer: JSON.stringify(res.data || defaultBuffer)
            };

            if (activePage) {
              let modifiedPayload = {
                existingFormId: activePageNew?.existingFormId,
                formBuffer: activePageNew?.formBuffer,
                formId: activePageNew?.formId,
                formImage: activePageNew?.formImage,
                formName: activePageNew?.formName,
                templateId: activePageNew?.templateId
              };
              await axios
                .post(`interfaces/`, sanitizeJson(modifiedPayload), { withCredentials: true })
                .then((res) => {
                  // console.log("SAVED PAGE 2");
                  if (activeApplication.defaultFormId) {
                    if (!silentSave) {
                      setAlertData({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "success",
                        alertContentKey: `${t("Portal Saved Successfully")}`
                      });
                    }
                    window.loading(false);
                    
                    if (window.openApplicationPreview && str === "openApplicationPreview") {
                      window.openApplicationPreview(activeApplication1);
                    }
                    if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview") {
                      window.OpenSelectedPagePreview(activeApplication1);
                    }
                  } else {
                    if (!silentSave) {
                      setAlertData({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "success",
                        alertContentKey: "TEMPLATE SAVED SUCCESSFULLY"
                      });
                    }
                    if (window.openApplicationPreview && str === "openApplicationPreview") {
                      window.openApplicationPreview(activeApplication1);
                    }
                    if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview") {
                      window.OpenSelectedPagePreview(activeApplication1);
                    }
                  }
                })
                .catch((err) => {
                  if(err?.response?.data?.statusCode){
                    setAlertData({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
                    });
                  }
                  console.log("ERROR FOUND in saving page: ", err);
                  reject("Issue in portal");
                  dispatch(updateStateInRedux({name:"saveload",key:props?.containerId,value:false}))
                });
            } else if (activeSubForm) {
              await axios
                .post(`widgets/`, sanitizeJson(activeSubFormNew), { withCredentials: true })
                .then((res) => {
                  // console.log("SAVED PAGE 2");
                  if (!silentSave) {
                    setAlertData({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "success",
                      alertContentKey: `${t("SaveFormSuccessMessage")}`
                    });
                  }

                  if (window.openApplicationPreview && str === "openApplicationPreview") {
                    window.openApplicationPreview(activeApplication1);
                  }
                  if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview") {
                    window.OpenSelectedPagePreview(activeApplication1);
                  }
                })
                .catch((err) => {
                  if(err?.response?.data?.statusCode){
                    setAlertData({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
                    });
                  }
                  reject("Issue in portal");
                   dispatch(updateStateInRedux({name:"saveload",key:props?.containerId,value:false}))
                  // console.log("ERROR FOUND in saving page: ", err);
                });
            }

            // if(activePage){
            //     axios.post(`interfaces/`,sanitizeJson(activePageNew),{withCredentials:true})
            //         .then(res=>{
            //             // console.log("SAVED PAGE 2");
            //         })
            //         .catch(err=>{
            //              console.log("ERROR FOUND in saving page: ", err);
            //         })
            // }
            setLatestChangesSaved(true);
            // if (window.openApplicationPreview && str === "openApplicationPreview"){
            //     window.openApplicationPreview(activeApplication1);

            // }
            // if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview"){
            //     window.OpenSelectedPagePreview(activeApplication1);
            // }
            // if ((window.openApplicationPreview === undefined || window.openApplicationPreview === null) && str === "openApplicationPreview"){
            //     openPreviewFromPmWeb(activeApplication1);

            // }

            if (activeApplication?.templatecategory === "PAGE") {
              let newTemplateVar = { ...activeApplication };
              // newTemplateVar["templatebuffer"] = JSON.stringify({children : formState2?.children})
              var newFormState2 = { ...formState2, ElementCount: flag2.current };
              newTemplateVar["templatebuffer"] = JSON.stringify(newFormState2);
              const removeArray = ["activeFormPageType", "activeIdentifierId", "activeStatusType", "headerJSON"];
              removeArray.forEach((key) => {
                delete newTemplateVar[key];
              });
              await axios
                .post("/templates/", newTemplateVar, { withCredentials: true })
                .then((res) => {
                  if (!silentSave) {
                    setAlertData({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "success",
                      alertContentKey: `${t("PAGE SAVED SUCCESSFULLY")}`
                    });
                  }
                  if (window.openApplicationPreview && str === "openApplicationPreview") {
                    window.openApplicationPreview(activeApplication1);
                  }
                  if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview") {
                    window.OpenSelectedPagePreview(activeApplication1);
                  }
                })
                .catch((err) => {
                  console.log("ERROR Found in saving portal");
                  reject("Issue in portal");
                });
            }

            if (activeApplication?.templatecategory === "FORM") {
              let newTemplateVar1 = { ...activeApplication };
              // newTemplateVar1["templatebuffer"] = JSON.stringify({children : formState2?.children})
              var newFormState2 = { ...formState2, ElementCount: flag2.current };
              newTemplateVar1["templatebuffer"] = JSON.stringify(newFormState2);

              const removeArray = ["activeFormPageType", "activeIdentifierId", "activeStatusType", "headerJSON"];
              removeArray.forEach((key) => {
                delete newTemplateVar1[key];
              });
              await axios
                .post("/templates/", newTemplateVar1, { withCredentials: true })
                .then((res) => {
                  if (!silentSave) {
                    setAlertData({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "success",
                      alertContentKey: `${t("SaveFormSuccessMessage")}`
                    });
                  }
                  // window.formBuffer = JSON.parse(res.data.fragmentBuffer)
                  if (window.openApplicationPreview && str === "openApplicationPreview") {
                    window.openApplicationPreview(activeApplication1);
                  }
                  if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview") {
                    window.OpenSelectedPagePreview(activeApplication1);
                  }
                })
                .catch((err) => {
                  console.log("ERROR Found in saving portal");
                  reject("Issue in portal");
                });
            }

            if (activeApplication?.defaultFormId) {
              // if(activeApplication?.defaultFormId || activeApplication?.templatecategory === "TEMPLATE"){
              const updatedHeaderJSON = contexts?.contexts?.headerJSON;
              const activeApplicationNew = {
                ...activeApplication,
                // "appimage":applicationScreenshot,
                appimage: "",
                headerJSON: JSON.stringify(updatedHeaderJSON || headerJSON)
              };
              // REMOVE BELOW
              const removeArray = [
                "categoryName",
                "createdBy",
                "creationDateTime",
                "formCount",
                "interfaceCount",
                "lastModifiedBy",
                "lastModifiedOn",
                "parentTableName",
                "widgetCount"
              ];
              removeArray.forEach((key) => {
                delete activeApplicationNew[key];
              });
              await axios
                .post(`applications/`, sanitizeJson(activeApplicationNew), { withCredentials: true })
                .then((res) => {
                  sendDocListData();
                  if (window.addtoRecentList_ides) {
                    window.addtoRecentList_ides({
                      ...formattedData,
                    }, "opened an application");
                  }
                })
                .catch((err) => {
                  console.log("ERROR FOUND in saving page: ", err);
                  reject("Issue in portal");
                });
            }

            if (activeApplication?.formPageType === "Portals") {
              if (activeApplication?.fragmentBuffer === undefined) {
                let newFormVar = { ...activeApplication };
                var newFormState2 = { ...formState2, ElementCount: flag2.current };
                newFormVar["formBuffer"] = JSON.stringify(newFormState2);
                let modifiedPayload = {
                  existingFormId: activeApplication?.existingFormId,
                  formBuffer: newFormVar?.formBuffer,
                  formId: activeApplication?.formId,
                  formImage: activeApplication?.formImage,
                  formName: activeApplication?.formName,
                  templateId: activeApplication?.templateId
                };
                await axios
                  .post(`interfaces/`, sanitizeJson(modifiedPayload), { withCredentials: true })
                  .then((res) => {
                    // console.log("SAVED PAGE 2");
                    if (!silentSave) {
                      setAlertData({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "success",
                        alertContentKey: `${t("PAGE SAVED SUCCESSFULLY")}`
                      });
                    }
                    if (window.openApplicationPreview && str === "openApplicationPreview") {
                      window.openApplicationPreview(activeApplication1);
                    }
                    if (window.OpenSelectedPagePreview && str === "OpenSelectedPagePreview") {
                      window.OpenSelectedPagePreview(activeApplication1);
                    }
                  })
                  .catch((err) => {
                    if(err?.response?.data?.statusCode){
                      setAlertData({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "error",
                        alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
                      });
                    }
                    console.log("ERROR FOUND in saving page: ", err);
                    console.log("ERROR FOUND in saving page: ", err);
                    reject("Issue in portal");
                  });
              }
            }
            dispatch(updateStateInRedux({name:"saveload",key:props?.containerId,value:false}))
          })
          .catch((err) => {
            console.log("ERROR FOUND in saving page: ", err);
            reject("Issue in portal");
             dispatch(updateStateInRedux({name:"saveload",key:props?.containerId,value:false}))
          });
      } else {
        if (!silentSave) {
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: `${t("Reopen_Form")}`
          });
        }
        reject("Issue in portal");
      }
      resolve("Portal Saved Successfully");
    });

    // ********************* FOR SAVING SCREEN SHOT IN CASE OF A APPLICATION START******************* //

    // ********************* FOR SAVING SCREEN SHOT IN CASE OF A APPLICATION END******************* //

    // handleClose();
  };

  function saveProcess(data, url,silentSave = false) {
    formState2.formName = microFrontendData?.formName;
    formState2.id = microFrontendData?.formDefId;

    var jsonToSend = {
      processDefId: microFrontendData?.processId,
      formId: microFrontendData?.formDefId,
      formName: microFrontendData?.formName || activeApplication?.formName,
      formBuffer: JSON.stringify(data)
    };

    // processState
    if (microFrontendData?.formPageType !== "Portals") {
      if (microFrontendData?.statusType === "L") {
        axios
          .post("process/local/form", jsonToSend, { withCredentials: true })
          .then((res) => {
            if (!silentSave) 
              {
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "success",
                  alertContentKey: `${t("SaveFormSuccessMessage")}`
                }); 
              }
       
            if (url !== "" && flag3?.current?.str === "openApplicationPreview") {
              if (
                url?.origin !== "" &&
                containerId === "mf_forms_customise" &&
                window.location.href.indexOf("processDesigner") > -1
              ) {
                // 👇️ setting target to _blank with window.open
                const url1 = `${url.origin}/psh/pmWebPreview`;
                // window.newMicroFrontendData = {...microFrontendData, url1}
                // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
                var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`);
                newPreviewVar.newMicroFrontendData = { ...microFrontendData, url1 };
              }
              if (url?.origin !== "" && window.location.href.indexOf("pmWebDesigner") > -1) {
                // 👇️ setting target to _blank with window.open
                const url1 = `${url.origin}/psh/pmWebPreview`;
                // window.newMicroFrontendData = {...microFrontendData, url1}
                // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
                var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`);
                newPreviewVar.newMicroFrontendData = { ...microFrontendData, url1 };
              }
            }
            if (window.openApplicationPreview && flag3?.current?.str === "openApplicationPreview") {
              window.openApplicationPreview(flag3?.current?.activeApplication1);
            }
            if (window.OpenSelectedPagePreview && flag3?.current?.str === "OpenSelectedPagePreview") {
              window.OpenSelectedPagePreview(flag3?.current?.activeApplication1);
            }
          })
          .catch((err) => {
             if(err?.response?.data?.status === "-3" || err?.status === "-3" || err?.data?.status === "-3"){
                 setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("Form has been corrupted please reopen this form")}`
              });
            }
            if(err?.response?.data?.statusCode){
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
              });
            }
            console.log("ERROR FOUND in saving page: ", err);
          });
      } else if (microFrontendData?.statusType === "R") {
        axios
          .post("process/registered/form", jsonToSend, { withCredentials: true })
          .then((res) => {
            if (!silentSave) 
              {
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "success",
                  alertContentKey: `${t("SaveFormSuccessMessage")}`
                });
                
              }
            if (url !== "" && flag3?.current?.str === "openApplicationPreview") {
              if (
                url?.origin !== "" &&
                containerId === "mf_forms_customise" &&
                window.location.href.indexOf("processDesigner") > -1
              ) {
                // 👇️ setting target to _blank with window.open
                const url1 = `${url.origin}/psh/pmWebPreview`;
                // window.newMicroFrontendData = {...microFrontendData, url1}
                // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
                var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`);
                newPreviewVar.newMicroFrontendData = { ...microFrontendData, url1 };
              }
              if (url?.origin !== "" && window.location.href.indexOf("pmWebDesigner") > -1) {
                // 👇️ setting target to _blank with window.open
                const url1 = `${url.origin}/psh/pmWebPreview`;
                // window.newMicroFrontendData = {...microFrontendData, url1}
                // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
                var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`);
                newPreviewVar.newMicroFrontendData = { ...microFrontendData, url1 };
              }
            }
            if (window.openApplicationPreview && flag3?.current?.str === "openApplicationPreview") {
              window.openApplicationPreview(flag3?.current?.activeApplication1);
            }
            if (window.OpenSelectedPagePreview && flag3?.current?.str === "OpenSelectedPagePreview") {
              window.OpenSelectedPagePreview(flag3?.current?.activeApplication1);
            }
          })
          .catch((err) => {
             if(err?.response?.data?.status === "-3" || err?.status === "-3" || err?.data?.status === "-3"){
                 setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("Form has been corrupted please reopen this form")}`
              });
            }
            if(err?.response?.data?.statusCode){
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
              });
            }
            console.log("ERROR FOUND in saving page: ", err);
          });
      }
    }
  }

  function downloadApplication() {
    let iframe = document.getElementById("hidden_iframe_downloadzip");

    if (iframe === null) {
      iframe = document.createElement("iframe");
    }

    iframe.id = "hidden_iframe_downloadzip";
    var ip = window.location.host;
    // if(ip==="localhost:3000"){
    //     ip="localhost:8080/"
    // }
    // else {
    ip = `${ip}/formBuilder`;
    // }

    const launchpadKey = secureLocalStorage.getItem("launchpadKey");
    var jwtToken = JSON.parse(launchpadKey)?.token || undefined;
    var srcAddress;
    srcAddress = `/formBuilder/download/taskForms/${microFrontendData.taskId}/${microFrontendData.processDefId}?Authorization=${jwtToken}`;

    iframe.src = srcAddress;
    document.body.appendChild(iframe);

    document.getElementById("hidden_iframe_downloadzip").style = "display:none";

    // setTimeout(function () {

    //       document.body.removeChild(iframe);
    // }, 2000);

    // downloadJson(json,appName);
  }
  window.callSpecifiedFunctions1 = function (extraFunctionCall, url, openApplicationPreview1, silentSave = false) {
    functions.fixElementIndex();
    let formStateToSend = {};
    if (Object.keys(formState2).length === 0) {
      formStateToSend = getFormJsonFromStore();
    } else {
      formStateToSend = cloneDeep(formState2);
    }
    var formBufferData = {
      formBuffer: JSON.stringify(formStateToSend)
    };

    if (Object.keys(formStateToSend).length !== 0 && Object.keys(formStateToSend?.children).length > 0) {
      formStateToSend.formName = activePage?.formName || microFrontendData?.formName ||formState2.formName || "testprocess";
      formStateToSend.id = microFrontendData?.formDefId;
      formStateToSend.formId = `${
        microFrontendData?.formDefId ||
        activePage?.formId ||
        activeSubForm?.fragmentId ||
        microFrontendData?.processDefId ||
        microFrontendData?.templateId
      }`;
      var updatedJson;
      axios
        .post("idesign/updateElementCountInJson", sanitizeJson(formStateToSend), { withCredentials: true })
        .then((res) => {
          // console.log("SAVED PAGE");
          updatedJson = res.data;
          saveProcess(res.data, url,silentSave);
          formState2.ElementCount = { ...res.data.ElementCount }
          setFormState2(formState2);
          const activePageNew = {
            ...activePage,
            formBuffer: JSON.stringify(res.data),
            headerJSON: headerJSON || {},
            islogin: islogin || "N"
          };
          if (activePage) {
            window.activityStream(
              "Username has modified interface " + activePage.formName,
              206,
              -1,
              -1,
              activePage.formId
            );
          }

          // const santizedPageNew=sanitizeJson(activePageNew);

          const activeSubFormNew = {
            ...activeSubForm,
            fragmentBuffer: JSON.stringify(res.data)
          };

          if (activePage) {
            let modifiedPayload = {
              existingFormId: activePageNew?.existingFormId,
              formBuffer: activePageNew?.formBuffer,
              formId: activePageNew?.formId,
              formImage: activePageNew?.formImage,
              formName: activePageNew?.formName,
              templateId: activePageNew?.templateId
            };
            axios
              .post(`interfaces/`, sanitizeJson(modifiedPayload), { withCredentials: true })
              .then((res) => {
                // console.log("SAVED PAGE 2");
              })
              .catch((err) => {
                if(err?.response?.data?.statusCode){
                  setAlertData({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
                  });
                }
                // console.log("ERROR FOUND in saving page: ", err);
                console.log("ERROR FOUND in saving page: ", err);
              });
          } else if (activeSubForm) {
            axios
              .post(`widgets/`, sanitizeJson(activeSubFormNew), { withCredentials: true })
              .then((res) => {
                // console.log("SAVED PAGE 2");
              })
              .catch((err) => {
                if(err?.response?.data?.statusCode){
                  setAlertData({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `${t("There is some issue at server end. Kindly check with system administrator.")}`
                  });
                }
                console.log("ERROR FOUND in saving page: ", err);
              });
          }

          // if(activePage){
          //     axios.post(`interfaces/`,sanitizeJson(activePageNew),{withCredentials:true})
          //         .then(res=>{
          //             console.log("SAVED PAGE 2");
          //         })
          //         .catch(err=>{
          //             console.log("ERROR FOUND in saving page: ", err);
          //         })
          // }
          if (microFrontendComponentType === "TF") {
            axios
              .post(
                `updateTaskform/${microFrontendData.taskId}/${microFrontendData.processDefId}`,
                { formBuffer: JSON.stringify(res.data) },
                { withCredentials: true }
              )
              .then((response) => {
                if (!silentSave) 
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "success",
                  alertContentKey: `${t("SaveFormSuccessMessage")}`
                });
                if (
                  url?.origin !== "" &&
                  containerId === "mf_forms_int_des" &&
                  window.location.href.indexOf("processDesigner") > -1 &&
                  microFrontendData?.componentType === "TF"
                ) {
                  // 👇️ setting target to _blank with window.open
                  const url1 = `${url.origin}/psh/pmWebPreview`;
                  // window.newMicroFrontendData = {...microFrontendData, url1}
                  // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
                  var newTaskFormPreview = window.open(`${url.origin}/psh/pmWebPreview`);
                  newTaskFormPreview.newMicroFrontendData = { ...microFrontendData };
                }
              })
              .catch((err) => {});
          } else if (microFrontendComponentType === "GT") {
            axios
              .post(
                `tasktemplateform/`,
                {
                  formBuffer: JSON.stringify(res.data),
                  templateId: microFrontendData.templateId,
                  templateName: microFrontendData.formName,
                  statusFlag: "P"
                },
                { withCredentials: true }
              )
              .then((response) => {
                if (!silentSave)
                setAlertData({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "success",
                  alertContentKey: `${t("SaveFormSuccessMessage")}`
                });
                if (
                  url?.origin !== "" &&
                  containerId === "mf_forms_int_des" &&
                  window.location.href.indexOf("processDesigner") > -1 &&
                  microFrontendData?.componentType === "GT"
                ) {
                  // 👇️ setting target to _blank with window.open
                  // window.callSpecifiedFunctions1(saveFormState, url)
                  const url1 = `${url.origin}/psh/pmWebPreview`;
                  // window.newMicroFrontendData = {...microFrontendData, url1}
                  // var newPreviewVar = window.open(`${url.origin}/psh/pmWebPreview`, '_blank', 'noopener,noreferrer');
                  var newTaskFormPreview = window.open(`${url.origin}/psh/pmWebPreview`);
                  newTaskFormPreview.newMicroFrontendData = { ...microFrontendData };
                }
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {
          console.log("ERROR FOUND in saving page: ", err);
        });

      setLatestChangesSaved(true);
      if (extraFunctionCall) {
        extraFunctionCall();
      }
      if (openApplicationPreview1) {
        openApplicationPreview1(url);
      }

      const toUpdateElemCountJson = {
        formJson: JSON.stringify(formStateToSend)
      };

      const formattedData = { ...activeApplication, lastModifiedOn: new Date() || "" };
      if (window.addtoRecentList_ides) {
        window.addtoRecentList_ides(formattedData, "opened an application");
      }

      // ********************* FOR SAVING SCREEN SHOT IN CASE OF A APPLICATION START******************* //

      if (activeApplication) {
        const activeApplicationNew = {
          ...activeApplication,
          appimage: ""
          // "appimage":applicationScreenshot
        };

        // axios.post(`applications/`,sanitizeJson(activeApplicationNew),{withCredentials:true})
        // .then(res=>{
        //     sendDocListData();
        //     // console.log("Application Image Saved");
        // })
        // .catch(err=>{
        //      console.log("ERROR FOUND in saving page: ", err);
        // })
      }
      // ********************* FOR SAVING SCREEN SHOT IN CASE OF A APPLICATION END******************* //

      // handleClose();
    } else {
      if (!silentSave) {
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Reopen_Form")}`
        });
      }
    }
  };

  function takeScreenShotOnHomePage() {
    // console.log("takescreenshot", activeApplication , activePage);
    // if(activeApplication?.defaultFormId === activePage?.formId){
    //  window?.takeScreenshot()
    // }
  }

  return (
    <>
      {activeApplication && document.querySelector("#interfaceDesignerMain") ? (
        null
      ) : (
        <div tabIndex={0} className={style.saveButton}>
          <SimpleLoader open={openLoader.current} />
          <div
            className={style.saveBtnLabel}
            onClick={() => window.callSpecifiedFunctions1(saveFormState)}
            // onMouseEnter={()=>window.takeScreenshot()}
          >
            {t("Save")}
          </div>

          {microFrontendData?.componentType === "TF" ? (
            <span
              onClick={() => {
                document.querySelector("#preview_FocusableDiv_header")?.focus();
              }}
              style={{ margin: "0 5px", position: "relative", display: "flex", alignItems: "center" }}
            >
              <DownArrow1 />
              <div
                onClick={() => downloadApplication()}
                tabIndex={0}
                id="preview_FocusableDiv_header"
                className={`${classes.previewButton} ${classes.saveDropDown}`}
              >
                <span className={style.previewBtnLabel} style={{ margin: "0 5px" }}>
                  {t("Save Form in local")}
                </span>
              </div>
            </span>
          ) : null}
        </div>
      )}

      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </>
  );
};

export default SaveOption;
